<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

// computed
const currentSeries = computed(() => store.getters.comicSeries)
const currentBook = computed(() => store.getters.book)

</script>

<template>
  <div>
    {{ currentSeries }}: {{ currentBook }}
  </div>
</template>

<style scoped lang="scss">

</style>
